<template>
    <div class="wrapper">
        <el-form
                ref="form"
                :model="form"
                :rules="rules"
                v-loading="isBusy"
                element-loading-spinner="el-icon-loading"
                label-width="170px"
        >
            <el-form-item label="Start" prop="from">
                <el-date-picker
                        v-model="form.from"
                        placeholder="Start"
                        clearable
                        :format="dateFormat"
                        :value-format="formDateFormat"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="End" prop="till">
                <el-date-picker
                        v-model="form.till"
                        placeholder="End"
                        clearable
                        :format="dateFormat"
                        :value-format="formDateFormat"
                ></el-date-picker>
            </el-form-item>
        </el-form>
        <el-button type="primary" @click="store">Save</el-button>
    </div>
</template>

<script>
  import BaseForm from '../form';
  import FileSaver from 'file-saver';

  export default {
    extends: BaseForm,

    props: {
      storeUrl: String,
    },

    data() {
      const form = {
        from: null,
        till: null,
      };

      return {
        form,
        rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
      }
    },

    computed: {
      /**
       * @return {String}
       */
      dateFormat() {
        return config('format.element.short.date');
      },

      /**
       * @return {String}
       */
      formDateFormat() {
        return config('format.date');
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      store() {
        this.isBusy = true;
        axios.post(this.storeUrl, this.getForm(), {
          responseType: 'blob',
        })
          .then(this.storeSuccess)
          .catch(this.handleErrorResponse)
          .then(() => this.isBusy = false);
      },

      /**
       * @param {Object} res
       * @return {boolean}
       */
      storeSuccess(res) {
        FileSaver.saveAs(res.data, this.getFileName(res));
        this.$emit('stored', {});
      },

      /**
       * @param {object} res
       */
      getFileName(res) {
        return _.chain(res)
          .get('headers.content-disposition', '')
          .thru(val => RegExp('filename="(.*?)"').exec(val))
          .get('1', 'conversation.xls')
          .value();
      },

      /**
       * @param {Object} response
       * @return {boolean}
       */
      async handleErrorResponse({response: {data, status}}) {
        const {errors, message} = JSON.parse(await data.text() || '{}');
        if (status === 422 && errors) {
          this.errors = errors;
          this.$refs.form.validate(() => null);
          this.$message.error(message);
        } else if (message && _.isString(message)) {
          this.$message.error(message);
        }

        return false;
      },

      /**
       * @param {Object} model
       */
      initForm(model) {
        this.form = _.mapValues(this.form, (val, prop) => _.get(model, prop, null));
      },
    }
  }
</script>
